import LogoMark from "@/components/LogoMark";

export default function Loading() {
    return (
        <div className="w-screen h-screen top-0 left-0 bg-beige-200 z-50 fixed flex justify-center items-center text-green-100">
            <LogoMark className="animate-fill" />
        </div>
    );
}